/**
 * @generated SignedSource<<b5bb7e701f758fae730257fae618718e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BidSuccessfulContent_nftItem$data = {
  readonly metadata: {
    readonly media?: {
      readonly posterFrameUrl: string | null;
      readonly webUrl: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "BidSuccessfulContent_nftItem";
};
export type BidSuccessfulContent_nftItem$key = {
  readonly " $data"?: BidSuccessfulContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"BidSuccessfulContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BidSuccessfulContent_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "posterFrameUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "e9aeeda977923b62ac5db2fc0ca0f655";

export default node;
